/* Publish by EComposer at 2026-09-30 16:26:40*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fxg8nk2zmwk"]=  window.__ectimmers["ecom-fxg8nk2zmwk"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-fxg8nk2zmwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxg8nk2zmwk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xcsekkbod7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xcsekkbod7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khriq1s7cze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khriq1s7cze', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hks7iworsdc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hks7iworsdc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0cz5rb7qas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0cz5rb7qas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8an9ccotfz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8an9ccotfz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hlktfjvx71e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hlktfjvx71e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cie0zwf8s5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cie0zwf8s5k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5v8zrm528f8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5v8zrm528f8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1m9gvdumqqk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1m9gvdumqqk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4giht5korjn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4giht5korjn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gxpp84duffn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gxpp84duffn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0etrx6n9zp28').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0etrx6n9zp28', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xovu0o8ttbo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xovu0o8ttbo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sq3qpjwgi3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sq3qpjwgi3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htsy00019').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htsy00019', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mkic8nzfp3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mkic8nzfp3o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1iyqbvnby44').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1iyqbvnby44', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iz9yi1of7tp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iz9yi1of7tp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjjjeli877').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjjjeli877', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hf91tvk17n"]=  window.__ectimmers["ecom-hf91tvk17n"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-hf91tvk17n"]["me8jl0m46"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-hf91tvk17n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hf91tvk17n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h2jana2t87l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h2jana2t87l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eq9n31xo825').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eq9n31xo825', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8s3ode7d2ot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8s3ode7d2ot', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-605ccoh7r7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-605ccoh7r7i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1nlhmsvg4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1nlhmsvg4', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5hbk05syvks"]=  window.__ectimmers["ecom-5hbk05syvks"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-5hbk05syvks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5hbk05syvks', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ggx5ir7ok1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ggx5ir7ok1g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4aw07jl2muf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4aw07jl2muf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6f73k6u7cau').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6f73k6u7cau', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e8spkbll77e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e8spkbll77e', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}